import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  switchHighlight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    width: '100%',
    margin: 0,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: `2px solid ${theme.palette.warning.main}`,
    transition: 'background-color 0.2s, border-color 0.2s',
  },
  switchHighlightActive: {
    border: `2px solid ${theme.palette.success.main}`,
  },
  switchLabelText: {
    fontWeight: theme.typography.fontWeightBold,
  },
  switchStatusText: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.warning.dark,
  },
  switchStatusTextActive: {
    color: theme.palette.success.dark,
  },
}))

export default useStyles
